import { Box } from "@mui/material";
import { memo, useMemo } from "react";
import { TDocumentData } from "../../models";
import { FileContent } from "../FileContent";
import { AccordionShell } from "../StepAccordion/AccordionShell";
import { IdentificationReportContent } from "./IdentificationReportContent";
import { ScreeningReportContent } from "./ScreeningReportContent";
import type { DocumentTypeRendererProps } from "./DocumentTypeRenderer";

function splitData(data: TDocumentData[]) {
  const binary: TDocumentData[] = [];
  const file: TDocumentData[] = [];
  for (const item of data) {
    if (item.type === "binary") binary.push(item);
    else if (item.type === "file") file.push(item);
  }
  return { binary, file };
}

export const SelfieRenderer = memo((props: DocumentTypeRendererProps) => {
  const {
    document,
    requestId,
    companyRole,
    comments,
    addComment,
    defaultExpanded,
  } = props;

  const { binary, file } = useMemo(() => splitData(document.data), [document.data]);

  const reportEntries = useMemo(
    () =>
      binary.filter(
        (d) =>
          d.dataId === "IdentificationReport" || d.dataId === "ScreeningReport"
      ),
    [binary]
  );
  const documentId = document.document.documentId;

  return (
    <AccordionShell
      title="Selfie"
      document={document}
      companyRole={companyRole}
      comments={comments}
      addComment={addComment}
      defaultExpanded={defaultExpanded}
    >
      {reportEntries.map((dataItem) =>
        dataItem.dataId === "IdentificationReport" ? (
          <IdentificationReportContent
            key={dataItem.id}
            data={dataItem}
            setDataFields={() => undefined}
            dataFields={{}}
            allDisabled
          />
        ) : (
          <ScreeningReportContent
            key={dataItem.id}
            data={dataItem}
            setDataFields={() => undefined}
            dataFields={{}}
            allDisabled
          />
        )
      )}
      {file.length > 0 && (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1.5 }}>
          {file.map((fileItem) => (
            <FileContent
              key={fileItem.id}
              requestId={requestId}
              documentId={documentId}
              fileId={fileItem.dataId}
              dataLink={fileItem.dataLink}
              fileInfo={fileItem.fileInfo}
            />
          ))}
        </Box>
      )}
    </AccordionShell>
  );
});
